export const maxContentWidth = 1100;
export const halfMaxContentWidth = maxContentWidth / 2;

export const mobileMaxWith = 520;
export const smallMaxWith = 750;
export const mediumMaxWith = 980;
export const largeMaxWith = 1450;
